<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar
          v-model="formData"
          @search="handleSearch"
          @onCollapse="onCollapse"
          ref="search"
        ></search-bar>
      </el-header>
      <el-main ref="main">
        <div style="margin-bottom: 5px;text-align: right;">
          <el-button type="primary" size="small" @click="exportShow"
            >导出</el-button
          >
          <!-- <el-popover
            placement="bottom"
            width="300"
            v-model="popoverVisible">
            <el-checkbox v-model="checkAll" @change="handleCheckALl">全选</el-checkbox>
            <el-checkbox-group v-model="propList" @change="screen">
              <el-checkbox :label="item" v-for="(item, index) in allPropList" :key="index" style="width: 120px">{{item.label}}</el-checkbox>
            </el-checkbox-group>
            <el-button slot="reference" size="small" style="float: right;">筛选</el-button>
          </el-popover> -->
          <el-button
            type="primary"
            slot="reference"
            size="small"
            @click="tableVisible = true"
            >表格设置</el-button
          >
        </div>
        <el-table
          ref="table"
          border
          stripe
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData"
          :height="tableHeight"
          v-if="tableHeight && tableReload"
          v-loading="loading"
          @sort-change="sortChange"
        >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :align="item.align"
            :fixed="item.fixed"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
          >
            <template slot="header">
              <template v-if="item.prop == 'buyNum'">
                <span>{{item.label}}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <span class="el-icon-question"></span>
                  <div slot="content">
                    包含京东入仓销量
                  </div>
                </el-tooltip>
              </template>
            </template>
            <template slot-scope="scope">
              <template v-if="item.label === '图片'">
                <el-link
                  v-if="showDetailBtn(scope.row, 0)"
                  :underline="false"
                  type="primary"
                  @click="showDialog(scope.row, 0)"
                  >查看</el-link
                >
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: left; margin-top: 15px; color: #555555">
          <span>{{ timeText.updateContent ? '数据刷新时间：' : ''}}</span>
          <span>{{ timeText.latestUpdateTime ? timeText.latestUpdateTime : ''}}</span>
        </div>
        <div style="float:right; margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <!-- 视频、图片查看 -->
    <pic-video
      v-model="picVideoVisible"
      :data="rowData"
      :detailType="viewType"
      v-if="picVideoVisible"
    ></pic-video>
    <!-- 导出 -->
    <v-export
      v-model="exportDialogVisible"
      :form="formData"
      :columnData="columnData"
      :imgDisabled="imgDisabled"
      v-if="exportDialogVisible"
    ></v-export>

    <!-- <el-dialog
      :visible.sync="tableVisible"
      title="表格设置"
      width="40%"
      @close="closeAddForm"
    >
      <custom-table :tableDataSet="tableDataSet"></custom-table>
      <div slot="footer" style="text-align: right">
        <el-button @click="closeAddForm">取消</el-button>
        <el-button type="primary" @click="confirm"> 确认 </el-button>
      </div>
    </el-dialog> -->
    <custom-table
      v-model="tableVisible"
      :tableDataSet="tableDataSet"
      v-if="tableVisible"
      @closeAddForm="closeAddForm"
      @confirm="confirm"
    ></custom-table>
  </div>
</template>

<script>
import exportMixin from "./export.mixin";
import picVideoMxin from "./pic&video.mixin";
import "element-ui/lib/theme-chalk/display.css";
import searchBar from "./search";
import customPropsMixin from "./customProps.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "GoodsAnalysisInfo",
  mixins: [picVideoMxin, exportMixin, customPropsMixin, pagePathMixin],
  components: {
    searchBar,
  },
  data() {
    return {
      tableHeight: 0,
      loading: false,
      formData: {
        category: "",
        material: "",
        color: "",
        length: "",
        price: "",
        saleNum: "",
      },
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      descOrAsc: "",
      fieldName: "",
      lastquery: {},
      timeText: {}
    };
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (
          olv.path == "/goods-overview" &&
          (val.query.category != this.lastquery.category ||
            val.query.color != this.lastquery.color ||
            val.query.length != this.lastquery.length ||
            val.query.material != this.lastquery.material ||
            val.query.price != this.lastquery.price)
        ) {
          this.lastquery = val.query;
          this.formData = { ...this.formData, ...this.$route.query };
          this.init();
        }
      },
    },
  },
  mounted() {
    this.tableHeight = this.$refs["wrapper"].offsetHeight - 125;
    this.formData = { ...this.formData, ...this.$route.query };
    this.init();
    this.refreshTime()
  },
  computed: {
    imgDisabled() {
      return !this.columnData.map((v) => v.label).includes("图片");
    },
  },
  methods: {
    handleSearch(data) {
      this.paginationOpt.pageNum = 1
      this.descOrAsc = ''
      this.$refs.table.clearSort();
      this.formData = data;
      this.init();
    },
    // screen(val) { //筛选
    //   if (this.propList.length == this.allPropList.length) {
    //     this.checkAll = true;
    //   } else {
    //     this.checkAll = false;
    //   }
    //   let change = val.map(v=>v.prop)
    //   let columnsData = this.columnsData.sysColumns
    //   let data = columnsData.filter(v=>change.includes(v.columnName))
    //   this.$q.goods.operate({ data: data}).then(res => {
    //     console.log(res);
    //   });
    // },
    init() {
      this.loading = true;
      let formData = {
        exportTag: true,
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          descOrAsc: this.descOrAsc,
          fieldName: this.fieldName,
        },
      };
      this.$q.goodsAnalysis
        .productAnalyzeDetail({ data: formData })
        .then((res) => {
          this.tableData = res.data.records;
          this.paginationOpt["total"] = res.data.total;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    sortChange({ column, prop, order }) {
      this.paginationOpt.pageNum = 1
      this.fieldName = prop;
      this.descOrAsc =
        order === "descending" ? "desc" : order === "ascending" ? "" : "";
      this.init();
    },
    async refreshTime() {
      let res = await this.$q.common.refreshTime({fragment: [57]})
      this.timeText = res.data
    },
    onCollapse() {
      // 搜索栏折叠展开的动画结束后才能计算最新的dom高度。不能用this.$nextTick替代。
      setTimeout((_) => {
        this.tableHeight =
          this.$refs["wrapper"].offsetHeight -
          this.$refs["search"].$el.offsetHeight -
          91;
      }, 500);
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 10px);
  box-sizing: border-box;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

>>> .el-header .el-form--inline .el-form-item {
  margin-right: 0px !important
} 

>>> .el-main {
  padding: 5px 8px;
  background: #ffffff;
  border-radius: 5px;
}
</style>